import {
  initialAccountState,
  initialAffiliateState,
  initialAgentState,
  initialBankDetailsState,
  initialCookieState,
  initialDiscountState,
  initialHouseInformationState,
  initialPackagePrice,
  initialPersonalDetailsState,
  initialReferralState,
  initialUiState,
} from "@/store/initialState";

export default {
  leadId: null,
  minHousemateCount: 1,
  maxHousemateCount: 15,
  housemateCount: 4,
  products: [],
  packagePrice: initialPackagePrice(),
  pickedProductPrices: [0, 0, 0, 0],
  pickedProductPriceCodes: {},
  unpickedProductPriceCodes: {},
  selectedAutocompletedAddress: null,
  uiState: initialUiState(),
  referral: initialReferralState(),
  affiliate: initialAffiliateState(),
  agent: initialAgentState(),
  discount: initialDiscountState(),
  houseInformation: initialHouseInformationState(),
  addressId: "",
  personalDetails: initialPersonalDetailsState(),
  bankDetails: initialBankDetailsState(),
  accountInformation: initialAccountState(),
  cookieState: initialCookieState(),
  cookieBannerExpanded: false,
  validationErrors: {},
  featureFlags: [],
  featureFlagsChecked: false,
};
